import React,{useState,useContext,useEffect} from "react";
import Loading from "../Loading";
import { setLoginMessage } from "../../apis/sharedata";
import {PageContext} from '../../PageContext';
import { postSignUp } from "../../apis/auth";
import {PAGE} from "../../constants"
import { Auth } from "aws-amplify";

export function SignupVC(){
    
    const[verificationComplete,setVerificationComplete] = useState(true);
    // const[verificationStatusMessage,setVerificationStatusMessage] = useState();
    const[isConfirmSignUpComplete,setIsConfirmSignUpComplete] = useState(false);
    const[email,setEmail] = useState("");
    const {page, setPage} = useContext(PageContext);

    useEffect(() => {
        let mounted = true;
        
        const queryParams = new URLSearchParams(window.location.search);
        let email = queryParams.get("userName");
        setEmail(email);
        let verificationCode = queryParams.get("verificationCode");
        console.log(`UseEffect SignupVC Email : ${email} VerificationCode ${verificationCode} `)
        
        if(mounted){
            // setVerificationStatusMessage(`Email Verification for ${email} is in Progess ....`)
            verifyEmail(email,verificationCode);
        }
        return () => {
            mounted = false;
        }
    });

    if(verificationComplete){
        setLoginMessage("Congratulations your Signup is complete. Please log with your credentials")
        setPage(PAGE.LOGIN)
    }

    async function verifyEmail(email,verificationCode) {
        //event.preventDefault();
        console.log("Inside onVerification");
        console.log(verificationCode);
        // setSignUpInProgress(true);
        await Auth.confirmSignUp(email, verificationCode)
        .then((res) => {
            if(res === "SUCCESS"){
               
                postSignUp(email)
                .then((res) => {
                    console.log("Displaying response from confirmSignUp "+res);
                    console.dir(res);
                    if(res != res.ok){       
                        return res.json();
                     }else{
                        const newLocal = "Post Signup failed. Response is not ok. Server Error";
                        console.error(newLocal);
                        throw new Error(newLocal);
                    }
                })
                .then((resdata)=>{
                     console.log(JSON.stringify(resdata))
                     console.log("redirecting to login page");
                    //  setSignUpInProgress(false);
                     setIsConfirmSignUpComplete(true);
                     
                })
                .catch((err)=>{
                    
                    console.error("PostSignUp failed with exception "+ err.message);
                    throw new Error(err.message);
                })
                
            }else{
                console.error("verification code confirmation failed");
                throw new Error("verification code confirmation failed");
            }
        })
        .catch((err)=> {
            console.error(err.message);
            throw new Error(err.message);
        })
            
        

    }


    return(

        <div className="topcontainer-signup">
           
            
            <p>Email Verification for ${email} is in Progress......</p>

        </div>

    )

}